const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".js-media-list") &&
		document.querySelectorAll(".js-media-list").length > 0
	) {
		document.querySelectorAll(".js-media-list").forEach((elem, index) => {
			const direction = elem.dataset.direction;
			let mousewheel = true;
			if (direction == "horizontal") {
				mousewheel = false;
			}

			const directionDesc = elem.dataset.direction_desc;

			let mousewheel_desc = true;
			if (directionDesc == "horizontal") {
				mousewheel_desc = false;
			}

			let slider = new Swiper(elem, {
				slidesPerView: 1,
				spaceBetween: 0,
				autoHeight: true,
				mousewheel: {
					enabled: mousewheel,
				},
				direction: direction,
				speed: 500,
				//freeMode: {
				//	enabled: !!elem
				//		.closest(".product__outer")
				//		.classList.contains("product__outer--multiple-top"),
				//	sticky: true,
				//},
				breakpoints: {
					750: {
						mousewheel: {
							enabled: mousewheel_desc,
						},
						direction: directionDesc,
					},
				},
				navigation: {
					nextEl: ".product .product__slider-nav .swiper-button-next",
					prevEl: ".product .product__slider-nav .swiper-button-prev",
				},
				pagination: {
					el: ".product .product__pagination",
					type: "bullets",
					clickable: true,
				},
				thumbs: {
					swiper: elem.nextElementSibling.querySelector(".js-media-sublist")
						? elem.nextElementSibling.querySelector(".js-media-sublist").swiper
						: "",
				},
				on: {
					//afterInit: function (swiper) {
					//	if (document.querySelector(".product__outer--multiple-top")) {
					//		document
					//			.querySelectorAll(".product__media-toggle")
					//			.forEach((elem, index) => {
					//				elem.addEventListener("click", (e) => {
					//					var target = e.currentTarget;

					//					if (
					//						document.querySelector(".js-popup-slider") &&
					//						document.querySelector(".js-popup-slider").swiper
					//					) {
					//						document
					//							.querySelector(".js-popup-slider")
					//							.swiper.slideTo(index);
					//					}
					//				});
					//			});
					//	}
					//},
					slideChangeTransitionStart: function () {
						if (document.querySelector(".js-media-sublist")) {
							document
								.querySelector(".js-media-sublist")
								.swiper.slideTo(
									document.querySelector(".js-media-list").swiper.activeIndex
								);
						}
					},
					slideChange: function () {
						window.pauseAllMedia();
						this.params.noSwiping = false;

						//if (
						//	document.querySelector(".js-popup-slider") &&
						//	document.querySelector(".js-popup-slider").swiper &&
						//	!document.querySelector(".product__outer--multiple-top")
						//) {
						//	document
						//		.querySelector(".js-popup-slider")
						//		.swiper.slideTo(this.activeIndex);
						//}
					},
					slideChangeTransitionEnd: function () {
						if (this.slides[this.activeIndex].querySelector("model-viewer")) {
							this.slides[this.activeIndex]
								.querySelector(".shopify-model-viewer-ui__button--poster")
								.removeAttribute("hidden");
						}
					},
					touchStart: function () {
						if (this.slides[this.activeIndex].querySelector("model-viewer")) {
							if (
								!this.slides[this.activeIndex]
									.querySelector("model-viewer")
									.classList.contains("shopify-model-viewer-ui__disabled")
							) {
								this.params.noSwiping = true;
								this.params.noSwipingClass = "swiper-slide";
							} else {
								this.params.noSwiping = false;
							}
						}
					},
				},
			});

			if (isUpdate) {
				setTimeout(function () {
					slider.update();
				}, 800);
			}
		});
	}
};

const subSliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".js-media-sublist") &&
		document.querySelectorAll(".js-media-sublist").length > 0
	) {
		document.querySelectorAll(".js-media-sublist").forEach((elem, index) => {

			if (index >= 1) return;

			const direction = elem.dataset.direction;

			let subSlider = new Swiper(elem, {
				slidesPerView: "auto",
				direction: direction,
				freeMode: false,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				autoHeight: true,
				on: {
					afterInit: function () {
						//this.params.slidesPerView = this.slides.length === 2 ? 2 : 3;
					},
					touchEnd: function (s, e) {
						let range = 5;
						let diff = (s.touches.diff = s.isHorizontal()
							? s.touches.currentX - s.touches.startX
							: s.touches.currentY - s.touches.startY);
						if (diff < range || diff > -range) s.allowClick = true;
					},
				},
				//transitionStart: function () {
				//	document
				//		.querySelector(".js-media-list")
				//		.swiper.slideTo(
				//			document.querySelector(".js-media-sublist").swiper.activeIndex,
				//		);
				//},
				//breakpoints: {
				//	576: {
				//		direction: "vertical",
				//		slidesPerView: "auto",
				//	},
				//},
			});

			const sliderResizeObserve = new ResizeObserver((entries) => {
				const [entry] = entries;
				setTimeout(() => {
					const sliders = document.querySelectorAll(".js-media-list");
					const thumbs = document.querySelectorAll(".product__media-sublist");
					if (sliders.length > 0 && thumbs.length > 0) {
						if (index >= 0 && index < sliders.length) {
							const sliderHeight =
								sliders[index].getBoundingClientRect().height;
							thumbs[index].style.height = `${sliderHeight - 1}px`;
						}
					}
				}, 400);
			});

			if (document.querySelector(".product-section"))
				sliderResizeObserve.observe(document.querySelector(".product-section"));

			if (isUpdate) {
				setTimeout(function () {
					subSlider.update();
				}, 800);
			}
		});
	}
};

const quickAddsliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".js-media-list") &&
		document.querySelectorAll(".js-media-list").length > 0
	) {
		document.querySelectorAll(".js-media-list").forEach((elem, index) => {
			let slider = new Swiper(elem, {
				slidesPerView: 1,
				spaceBetween: 0,
				autoHeight: true,
				speed: 500,
				direction: "horizontal",
				navigation: {
					nextEl: ".product .product__slider-nav .swiper-button-next",
					prevEl: ".product .product__slider-nav .swiper-button-prev",
				},
				pagination: {
					el: ".product .product__pagination",
					type: "bullets",
					clickable: true,
				},
				on: {
					// afterInit: function (swiper) {
					// 	if (document.querySelector(".product__outer--multiple-top")) {
					// 		document
					// 			.querySelectorAll(".product__media-toggle")
					// 			.forEach((elem, index) => {
					// 				elem.addEventListener("click", (e) => {
					// 					var target = e.currentTarget;

					// 					if (
					// 						document.querySelector(".js-popup-slider") &&
					// 						document.querySelector(".js-popup-slider").swiper
					// 					) {
					// 						document
					// 							.querySelector(".js-popup-slider")
					// 							.swiper.slideTo(index);
					// 					}
					// 				});
					// 			});
					// 	}
					// },
					// slideChangeTransitionStart: function () {
					// 	if (document.querySelector(".js-media-sublist")) {
					// 		document
					// 			.querySelector(".js-media-sublist")
					// 			.swiper.slideTo(
					// 				document.querySelector(".js-media-list").swiper.activeIndex,
					// 			);
					// 	}
					// },
					slideChange: function () {
						window.pauseAllMedia();
						this.params.noSwiping = false;

						// if (
						// 	document.querySelector(".js-popup-slider") &&
						// 	document.querySelector(".js-popup-slider").swiper &&
						// 	!document.querySelector(".product__outer--multiple-top")
						// ) {
						// 	document
						// 		.querySelector(".js-popup-slider")
						// 		.swiper.slideTo(this.activeIndex);
						// }
					},
					slideChangeTransitionEnd: function () {
						if (this.slides[this.activeIndex].querySelector("model-viewer")) {
							this.slides[this.activeIndex]
								.querySelector(".shopify-model-viewer-ui__button--poster")
								.removeAttribute("hidden");
						}
					},
					touchStart: function () {
						if (this.slides[this.activeIndex].querySelector("model-viewer")) {
							if (
								!this.slides[this.activeIndex]
									.querySelector("model-viewer")
									.classList.contains("shopify-model-viewer-ui__disabled")
							) {
								this.params.noSwiping = true;
								this.params.noSwipingClass = "swiper-slide";
							} else {
								this.params.noSwiping = false;
							}
						}
					},
				},
			});

			if (isUpdate) {
				setTimeout(function () {
					slider.update();
				}, 800);
			}
		});
	}
};

const popupSliderInit = (isUpdate) => {
	if (document.querySelector(".js-popup-slider")) {
		//let popupSlider = new Swiper(document.querySelector(".js-popup-slider"), {
		//	slidesPerView: 1,
		//	//navigation: {
		//	//	nextEl: ".product-media-modal .product__slider-nav .swiper-button-next",
		//	//	prevEl: ".product-media-modal .product__slider-nav .swiper-button-prev",
		//	//},
		//	//pagination: {
		//	//	el: ".product-media-modal .product__pagination",
		//	//	type: "bullets",
		//	//	clickable: true,
		//	//},
		//	on: {
		//		afterInit: function () {
		//			if (
		//				document.querySelector(
		//					".product__outer--static-multicolumns-aside"
		//				) ||
		//				document.querySelector(".product__outer--static-column-aside")
		//			) {
		//				document
		//					.querySelectorAll(".product__media-list .product__media-toggle")
		//					.forEach((elem, index) => {
		//						elem.addEventListener("click", (e) => {
		//							if (
		//								document.querySelector(".js-popup-slider") &&
		//								document.querySelector(".js-popup-slider").swiper
		//							) {
		//								document
		//									.querySelector(".js-popup-slider")
		//									.swiper.slideTo(index);
		//							}
		//						});
		//					});
		//			}
		//		},
		//		slideChange: function () {
		//			window.pauseAllMedia();
		//			this.params.noSwiping = false;
		//			document
		//				.querySelector(".product-media-modal__content")
		//				.classList.remove("zoom");
		//		},
		//		touchMove: function () {
		//			document
		//				.querySelector(".product-media-modal__content")
		//				.classList.remove("zoom");
		//		},
		//		slideChangeTransitionEnd: function () {
		//			if (this.slides[this.activeIndex].querySelector("model-viewer")) {
		//				this.slides[this.activeIndex]
		//					.querySelector(".shopify-model-viewer-ui__button--poster")
		//					.removeAttribute("hidden");
		//			}
		//		},
		//		touchStart: function () {
		//			if (this.slides[this.activeIndex].querySelector("model-viewer")) {
		//				if (
		//					!this.slides[this.activeIndex]
		//						.querySelector("model-viewer")
		//						.classList.contains("shopify-model-viewer-ui__disabled")
		//				) {
		//					this.params.noSwiping = true;
		//					this.params.noSwipingClass = "swiper-slide";
		//				} else {
		//					this.params.noSwiping = false;
		//				}
		//			}
		//		},
		//	},
		//});

		if (isUpdate) {
			setTimeout(function () {
				//popupSlider.update();
			}, 800);
		}
	}
};

(function () {
	const sidebar = () => {
		let pageNav = $(".product__media-sublist__sidebar-nav");

		if (pageNav.length > 0) {
			let pageNavList = pageNav.find("a");
			let adminBarHeight = 0;

			let headings = [];
			for (let i = 0; i < pageNavList.length; i++) {
				headings[i] = $($(pageNavList[i]).attr("href"));
			}

			$(pageNavList[0]).parent().addClass("active");

			pageNavList.on("click", function (e) {
				e.preventDefault();

				const targetId = $(this).attr("href");
				const targetElement = $(targetId);

				if (targetElement.length) {
					$(".product-media-modal__dialog").animate(
						{
							scrollTop:
								targetElement.position().top +
								$(".product-media-modal__dialog").scrollTop(),
						},
						100
					);
				}
			});

			$(".product-media-modal__dialog").on("scroll", function () {
				for (let i = headings.length - 1; i >= 0; i--) {
					if ($(headings[i]).length > 0) {
						if (
							$(headings[i]).offset().top - 50 <=
							$(window).scrollTop() + adminBarHeight
						) {
							if (!$(pageNavList[i]).parent().hasClass("active")) {
								let hasActiveItem = false;
								for (let j = i; j < headings.length; j++) {
									if ($(pageNavList[j]).parent().hasClass("active")) {
										hasActiveItem = true;
									}
								}

								if (!hasActiveItem) {
									$(pageNavList[i]).parent().addClass("active");
								}
							} else {
								for (let j = 0; j < i; j++) {
									$(pageNavList[j]).parent().removeClass("active");
								}
							}
						} else {
							if (i !== 0) {
								$(pageNavList[i]).parent().removeClass("active");
							}
						}
					}
				}
			});
		}
	};

	document.addEventListener("DOMContentLoaded", function () {
		sidebar();
		document.addEventListener("shopify:section:load", function () {
			sidebar();
		});
	});
})();

if (navigator.userAgent.indexOf("iPhone") > -1) {
	document
		.querySelector("[name=viewport]")
		.setAttribute(
			"content",
			"width=device-width, initial-scale=1, maximum-scale=1"
		);
}

/* 动效是表现，不是生命周期门槛：事件缺失、零时长与取消也要收尾。
   返回取消函数供关闭、重开与 section 卸载清掉旧回调；只接收目标自身事件。 */
function waitForThemeMotion(element, callback, options = {}) {
  const animation = options.type === 'animation';
  const endEvent = animation ? 'animationend' : 'transitionend';
  const cancelEvent = animation ? 'animationcancel' : 'transitioncancel';
  const properties = options.properties || ['transform'];
  let timer, completed = false;
  const cancel = () => {
    completed = true;
    clearTimeout(timer);
    element?.removeEventListener(endEvent, onEnd);
    element?.removeEventListener(cancelEvent, onEnd);
  };
  const finish = () => {
    if (completed) return;
    cancel();
    callback();
  };
  const onEnd = event => {
    if (event.target !== element) return;
    if (animation ? event.animationName !== options.name : !properties.includes(event.propertyName)) return;
    finish();
  };
  const style = element && getComputedStyle(element);
  const list = value => (value || '').split(',').map(item => item.trim());
  const milliseconds = value => (parseFloat(value) || 0) * (value?.endsWith('ms') ? 1 : 1000);
  const durations = list(animation ? style?.animationDuration : style?.transitionDuration);
  const delays = list(animation ? style?.animationDelay : style?.transitionDelay);
  const names = list(animation ? style?.animationName : style?.transitionProperty);
  const iterations = list(style?.animationIterationCount);
  const duration = Math.max(0, ...names.map((name, index) => {
    if (animation ? name !== options.name : name !== 'all' && !properties.includes(name)) return 0;
    const count = animation ? Number(iterations[index % iterations.length] || 1) : 1;
    if (!Number.isFinite(count)) return 0;
    return milliseconds(durations[index % durations.length]) * count + milliseconds(delays[index % delays.length]);
  }));
  element?.addEventListener(endEvent, onEnd);
  element?.addEventListener(cancelEvent, onEnd);
  // 下一任务即可完成零时长，调用方有机会先保存取消函数；不人为添加动画等待。
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  timer = setTimeout(finish, duration && !reduced ? duration + 50 : 0);
  return cancel;
}

// 抽屉动效可以按不同顺序结束；只有最近一次打开请求可以延后接管焦点。
// 关闭时仍由现有 releaseThemeScrollLock 恢复剩余面板，不能让较早的回调反抢焦点。
let themeDrawerFocusGeneration = 0;
function claimThemeDrawerFocus() {
  const generation = ++themeDrawerFocusGeneration;
  return () => generation === themeDrawerFocusGeneration;
}

// 测量指南用 transform 收尾，并管理自己的焦点和滚动锁；保留步骤、尺寸计算及 active 显隐约定。
const themeGuideMotionJobs = new WeakMap();
const themeGuideSessions = new Map();

function topThemeGuide() {
  return Array.from(themeGuideSessions.keys()).reverse().find(guide => guide.isConnected && themeGuideSessions.get(guide).isOpen());
}

function finishThemeGuide(container) {
  const session = themeGuideSessions.get(container);
  if (!session) return;
  session.cancelOpen?.();
  session.observer.disconnect();
  document.removeEventListener('keydown', session.onKey, true);
  document.removeEventListener('focusin', session.onFocus, true);
  themeGuideSessions.delete(container);
  const next = topThemeGuide();
  if (!next) document.body.classList.remove('theme-guide-scroll-locked');
  if (next) themeGuideSessions.get(next).focusFirst();
  else if (session.opener?.isConnected) session.opener.focus({ preventScroll: true });
}

function enhanceThemeGuideControls(panel) {
  // 图案由同一按钮的文字说明；避免装饰图重复播报或变成无说明图片。
  panel.querySelectorAll('.optionItem .itemBox img:not([alt])').forEach(image => image.setAttribute('alt', ''));
  panel.querySelectorAll('input:not([type="hidden"]), select, textarea').forEach(input => {
    if (input.getAttribute('aria-label') || input.getAttribute('aria-labelledby') || input.labels?.length) return;
    const step = input.closest('.stepBox')?.querySelector('.stepTitle p:last-child')?.textContent.trim();
    const hint = input.getAttribute('placeholder') || input.dataset.type || input.name;
    const name = [step, hint].filter(Boolean).join(' — ');
    if (name) input.setAttribute('aria-label', name);
  });
  const controls = panel.querySelectorAll('.step > div, .optionItem .itemBox, .btnList .btn:not(a):not(button)');
  const disabled = control => control.matches('[disabled=""], [disabled="true"], [disabled="disabled"]');
  const sync = () => controls.forEach(control => {
    control.setAttribute('aria-disabled', disabled(control) ? 'true' : 'false');
    control.setAttribute('tabindex', disabled(control) ? '-1' : '0');
    if (control.closest('.optionItem')) control.setAttribute('aria-pressed', control.closest('.optionItem').classList.contains('active') ? 'true' : 'false');
  });
  controls.forEach(control => {
    if (control.dataset.themeGuideControl) return;
    control.dataset.themeGuideControl = 'true';
    control.setAttribute('role', 'button');
    control.setAttribute('tabindex', '0');
    if (control.parentElement.classList.contains('step') && !control.hasAttribute('aria-label')) {
      control.setAttribute('aria-label', `Step ${Array.from(control.parentElement.children).indexOf(control) + 1}`);
    }
    control.addEventListener('keydown', event => {
      if (event.target !== control || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      if (!event.repeat && !disabled(control)) control.click();
    });
  });
  sync();
  if (!panel.dataset.themeGuideControls) {
    panel.dataset.themeGuideControls = 'true';
    panel.addEventListener('click', () => queueMicrotask(sync));
  }
  return sync;
}

function prepareThemeGuide(container, panel, opener, options = {}) {
  const icon = panel.querySelector('.popupTitle svg');
  if (!options.closeControl && icon && !icon.closest('button')) {
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'theme-guide-close';
    close.setAttribute('aria-label', 'Close size guide');
    icon.before(close);
    close.appendChild(icon);
    close.addEventListener('click', event => {
      event.stopPropagation();
      setThemeGuideOpen(container, false);
    });
  }
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  panel.setAttribute('tabindex', '-1');
  const syncGuideControls = !options.closeControl ? enhanceThemeGuideControls(panel) : null;
  if (!panel.hasAttribute('aria-label')) panel.setAttribute('aria-label', options.label || panel.querySelector('.popupTitle')?.textContent.trim() || 'Size guide');
  const pageOpener = options.closeControl ? null : document.querySelector('.popupOpen');
  if (pageOpener && !pageOpener.hasAttribute('tabindex')) {
    pageOpener.setAttribute('tabindex', '0');
    pageOpener.setAttribute('role', 'button');
    pageOpener.setAttribute('aria-label', 'Open size guide');
    pageOpener.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        pageOpener.click();
      }
    });
  }
  // 帮助页桌面指南是正文侧栏，保留键盘控件，但不接管焦点或锁定页面。
  if (options.modal === false) {
    finishThemeGuide(container);
    panel.setAttribute('role', 'region');
    panel.removeAttribute('aria-modal');
    return null;
  }
  if (themeGuideSessions.has(container)) return themeGuideSessions.get(container);
  const focused = document.activeElement;
  const session = { opener: opener || (focused && focused !== document.body && !container.contains(focused) ? focused : pageOpener) };
  const focusFirst = () => (options.closeControl || panel.querySelector('.theme-guide-close') || panel).focus({ preventScroll: true });
  session.focusFirst = focusFirst;
  session.isOpen = options.isOpen || (() => container.classList.contains('active'));
  session.onFocus = event => {
    if (topThemeGuide() === container && !container.contains(event.target)) focusFirst();
  };
  session.onKey = event => {
    if (topThemeGuide() !== container) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      if (options.close) options.close();
      else setThemeGuideOpen(container, false);
    } else if (event.key === 'Tab') {
      // 步骤切换会改变可见控件，每次按键重新取列表，不能圈到隐藏步骤。
      const bounds = panel.getBoundingClientRect();
      // 可见/inert/tabIndex 已由 getFocusableElements 过滤；这里只补非表单元素的 disabled 属性和横向裁切。
      const controls = getFocusableElements(panel).filter(control => {
        const rect = control.getBoundingClientRect();
        return !control.matches('[disabled=""], [disabled="true"], [disabled="disabled"]') && rect.right > bounds.left && rect.left < bounds.right;
      });
      const index = controls.indexOf(document.activeElement);
      const nextIndex = index < 0 ? (event.shiftKey ? controls.length - 1 : 0) : (index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
      const next = controls[nextIndex] || panel;
      event.preventDefault();
      event.stopPropagation();
      next.focus({ preventScroll: true });
    }
  };
  session.observer = new MutationObserver(() => {
    if (!container.isConnected || !session.isOpen()) {
      themeGuideMotionJobs.get(container)?.();
      finishThemeGuide(container);
    } else {
      options.sync?.();
      syncGuideControls?.();
    }
  });
  themeGuideSessions.set(container, session);
  document.addEventListener('keydown', session.onKey, true);
  document.addEventListener('focusin', session.onFocus, true);
  session.observer.observe(document.body, { childList: true, subtree: true });
  session.observer.observe(container, { attributes: true, attributeFilter: ['class', 'style', 'data-current'] });
  if (syncGuideControls) session.observer.observe(panel, { subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });
  return session;
}

// PDP 的小样弹窗仍使用原有显隐和选色代码，只补焦点、键盘关闭及自己的滚动锁。
function openThemeProductSwatchDialog(container, opener) {
  const panel = container?.querySelector('.popup');
  if (!panel) return;
  const close = panel.querySelector('.exit');
  panel.querySelectorAll('.exit, .arrow, .btn').forEach(control => {
    control.setAttribute('role', 'button');
    control.setAttribute('tabindex', '0');
    if (control === close) control.setAttribute('aria-label', 'Close fabric swatches');
    else if (control.classList.contains('arrow')) control.setAttribute('aria-label', control.classList.contains('left') ? 'Previous fabric swatch' : 'Next fabric swatch');
    if (!control.dataset.themeSwatchKeyboard) {
      control.dataset.themeSwatchKeyboard = 'true';
      control.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          control.click();
        }
      });
    }
  });
  const sync = () => {
    const current = Number(container.dataset.current) || 0;
    panel.querySelectorAll('.popupBox').forEach((box, index) => box.setAttribute('aria-hidden', index === current ? 'false' : 'true'));
    panel.querySelectorAll('.arrow, .btn').forEach(control => {
      const disabled = control.getAttribute('disabled') === 'true' || control.getAttribute('disabled') === 'disabled' || control.hasAttribute('sold_out');
      control.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      control.setAttribute('tabindex', disabled || control.closest('[aria-hidden="true"]') ? '-1' : '0');
    });
  };
  sync();
  const session = prepareThemeGuide(container, panel, opener, {
    closeControl: close, label: 'Fabric swatches', sync,
    isOpen: () => getComputedStyle(container).display !== 'none',
    close: () => container.click()
  });
  document.body.classList.add('theme-guide-scroll-locked');
  session.cancelOpen?.();
  session.cancelOpen = waitForThemeMotion(panel, () => {
    if (container.isConnected && session.isOpen() && topThemeGuide() === container) session.focusFirst();
  });
}

function setThemeGuideOpen(container, open, opener, options = {}) {
  if (!container) return;
  if (!open && !container.classList.contains('is-open')) return;
  themeGuideMotionJobs.get(container)?.();
  const panel = container.querySelector('.popupBox');
  if (!panel) return;
  container.classList.add('theme-guide-motion');
  panel.style.removeProperty('right');
  if (open) {
    const session = prepareThemeGuide(container, panel, opener, options);
    session?.cancelOpen?.();
    container.classList.add('active');
    if (session) document.body.classList.add('theme-guide-scroll-locked');
    getComputedStyle(panel).transform;
    container.classList.add('is-open');
    if (session) session.cancelOpen = waitForThemeMotion(panel, () => {
      if (container.isConnected && container.classList.contains('is-open') && topThemeGuide() === container) {
        (panel.querySelector('.theme-guide-close') || panel).focus({ preventScroll: true });
      }
    });
  } else {
    themeGuideSessions.get(container)?.cancelOpen?.();
    container.classList.remove('is-open');
    themeGuideMotionJobs.set(container, waitForThemeMotion(panel, () => {
      if (!container.classList.contains('is-open')) {
        container.classList.remove('active');
        finishThemeGuide(container);
      }
      themeGuideMotionJobs.delete(container);
    }));
  }
}

// 同时打开的主题面板共享 overflow-hidden；关闭一个不解除另一个的滚动锁。
function releaseThemeScrollLock() {
  const panels = Array.from(document.querySelectorAll('cart-drawer.active, search-modal.active, account-modal.active, modal-dialog[open], quick-add-modal[open]'));
  if (!panels.length) {
    document.body.classList.remove('overflow-hidden');
  } else {
    // removeTrapFocus 会先还给关闭者的触发点；仍有面板时必须重新接管焦点。
    // 保留已在面板内的当前控件，避免关闭底层面板时跳回顶层的首项。
    const current = document.activeElement;
    const remaining = panels.find(panel => panel.contains(current)) || panels[panels.length - 1];
    const target = remaining.contains(current) ? current : getFocusableElements(remaining)[0] || remaining.querySelector('[role="dialog"]');
    if (target) trapFocus(remaining, target);
  }
}

function getFocusableElements(container) {
	// 同一次调用里祖先大量重复：每个祖先的 content-visibility 只读一次。
	const hiddenContent = new Map();
	const contentHidden = (parent) => {
		if (!hiddenContent.has(parent)) hiddenContent.set(parent, getComputedStyle(parent).contentVisibility === "hidden");
		return hiddenContent.get(parent);
	};
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	).filter((element) => {
		if (element.tabIndex < 0 || element.matches(":disabled") ||
			!element.getClientRects().length || getComputedStyle(element).visibility === "hidden" ||
			element.closest('[inert], [aria-hidden="true"]')) return false;
		// 闭合 details 的内容仍可能有布局矩形，但浏览器不会把焦点移进去。
		// 只保留每层闭合 details 的首个 summary（及其可聚焦后代）。
		// 必须走完整条祖先链：容器本身也可能位于闭合 details 中（Chrome 实测仍有矩形却无法聚焦）。
		for (let parent = element.parentElement; parent; parent = parent.parentElement) {
			if (contentHidden(parent)) return false;
			if (parent.tagName === "DETAILS" && !parent.open) {
				const summary = Array.from(parent.children).find(child => child.tagName === "SUMMARY");
				if (!summary || !summary.contains(element)) return false;
			}
		}
		return true;
	});
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", "false");

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open")
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && !container.contains(event.target)) return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if ((event.code || event.key).toUpperCase() !== "TAB") return; // If not TAB key
		// Safari 的默认 Tab 顺序可能跳过链接；在模态内明确遍历可见控件，
		// 同时重读步骤和禁用状态，避免进入 Preview iframe 或背景。
		const controls = getFocusableElements(container);
		if (!controls.length) {
			event.preventDefault();
			container.focus();
			return;
		}
		const index = controls.indexOf(document.activeElement);
		const next = index < 0 ? (event.shiftKey ? controls.length - 1 : 0) : (index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
		event.preventDefault();
		controls[next].focus();
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus && elementToFocus.focus();
	// 触发按钮已经聚焦时 focus() 不再发出 focusin，仍需立即安装 Tab 处理。
	document.addEventListener("keydown", trapFocusHandlers.keydown);
}

function pauseAllMedia() {
	document
		.querySelectorAll(".product__media-list .js-youtube")
		.forEach((video) => {
			video.contentWindow.postMessage(
				'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
				"*"
			);
		});
	document
		.querySelectorAll(".product__media-list .js-vimeo")
		.forEach((video) => {
			video.contentWindow.postMessage('{"method":"pause"}', "*");
		});
	document
		.querySelectorAll(".product__media-list video")
		.forEach((video) => video.pause());
	document
		.querySelectorAll(".product__media-list product-model")
		.forEach((model) => {
			if (model.modelViewerUI) model.modelViewerUI.pause();
		});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus && !elementToFocus.classList.contains("card-focused"))
		elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) => {
			this.setMinimumDisable();

			button.addEventListener("click", this.onButtonClick.bind(this));
		});

		var eventList = ["paste", "input"];

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/;

				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ""
				) {
					e.currentTarget.value;
				} else {
					e.currentTarget.value = 1;
				}

				if (e.currentTarget.value === 1 || e.currentTarget.value === "") {
					this.previousElementSibling.classList.add("disabled");
				} else {
					this.previousElementSibling.classList.remove("disabled");
				}
			});
		}

		this.input.addEventListener("focusout", function (e) {
			if (e.currentTarget.value === "") {
				e.currentTarget.value = 1;
			}
		});
	}

	setMinimumDisable() {
		if (this.input.value == 1) {
			this.querySelector('button[name="minus"]').classList.add("disabled");
		} else {
			this.querySelector('button[name="minus"]').classList.remove("disabled");
		}
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);

		this.setMinimumDisable();
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

const serializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);
	for (const key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this)
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");
		this.menuMotionJobs = new WeakMap();
		const summaryElements = this.querySelectorAll("summary");
		this.addAccessibilityAttributes(summaryElements);

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();

		// 兜底：<details> 无论被什么方式打开（原生点击、键盘、别处代码设 open），
		// toggle 都会触发。正常路径上 onSummaryClick 已经先搬完内容，这里是空转。
		if (this.mainDetailsToggle) {
			this.mainDetailsToggle.addEventListener("toggle", () => {
				if (this.mainDetailsToggle.open) this.hydrateContent();
			});
		}

		// 内联兜底脚本可能在本元素升级之前就把正文搬进来了（用户抢在 global.js 执行前
		// 点了汉堡）。那种情况下 template 已经不在，光靠上面的 toggle / onSummaryClick
		// 要等用户再开关两轮才会走到 hydrateContent，所以这里立刻补做一次接管。
		// 条件收得很紧（只认兜底脚本留下的标记），mobile-facets 等同样继承 MenuDrawer、
		// 但从未延迟化的用法不会被误触发。
		if (this.querySelector(".menu-drawer--fallback")) this.hydrateContent();
	}

	// 可重复调用：抽屉正文是点开汉堡时才从 <template> 搬进来的（见 hydrateContent），
	// 那时要给新出现的 summary / button 补绑，但绝不能把已经绑过的再绑一遍 ——
	// 主 summary 被绑两次的话 onSummaryClick 会跑两遍，openMenuDrawer 立刻被
	// closeMenuDrawer 抵消，表现为"点汉堡没反应"。用 dataset 打标最省事。
	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) => {
			if (summary.dataset.menuDrawerBound) return;
			summary.dataset.menuDrawerBound = "1";
			summary.addEventListener("click", this.onSummaryClick.bind(this));
		});
		this.querySelectorAll("button").forEach((button) => {
			if (button.dataset.menuDrawerBound) return;
			if (this.querySelector(".toggle-scheme-button") === button) return;
			if (this.querySelector(".header__localization-button") === button) return;
			if (this.querySelector("button.header__localization-button") === button)
				return;
			if (
				this.querySelector("button.header__localization-lang-button") === button
			)
				return;
			button.dataset.menuDrawerBound = "1";
			button.addEventListener("click", this.onCloseButtonClick.bind(this));
		});
	}

	// 把 <template data-menu-drawer-content> 里的抽屉正文搬进 DOM，并给新节点补绑。
	// 没有那个 template 就什么都不做 —— mobile-facets 也用 MenuDrawer，它没有延迟化。
	// 把抽屉正文变成"已接管"状态：搬运 template（如果还在）+ 补绑 + 广播。
	//
	// 有两条进入路径，**都必须走完后半段**：
	//  a) 正常路径：template 还在，这里搬运并接管。
	//  b) 兜底路径：header-drawer.liquid 里那段内联脚本在 global.js 执行前就被点到了
	//     （global.js 是 defer，首页文档 700KB，慢网下有几秒真实窗口），它已经把
	//     template 搬完并删掉，还给面板打了 menu-drawer--fallback。
	//     早期版本在这里 `if (!tpl) return false` 直接退出，于是事件广播、GLC 重扫、
	//     摘标记全部落空 —— 菜单能用，但 By Color 色块不出现、暗色开关不绑、
	//     换汇访客的价格不重算，而且那个标记会一直留着（见下面移除它的理由）。
	hydrateContent() {
		const tpl = this.querySelector("template[data-menu-drawer-content]");
		const fallbackPanel = this.querySelector(".menu-drawer--fallback");
		// 两个标记都没有 = 已经接管过（或是 mobile-facets 这类本来就没延迟化的用法）。
		if (!tpl && !fallbackPanel) return false;

		if (tpl) {
			tpl.parentNode.appendChild(tpl.content);
			tpl.remove();
		}

		// 摘掉兜底标记。不摘的话 component-menu-drawer.css 里那条
		// `.menu-drawer--fallback details[open] > .menu-drawer__submenu{visibility:visible}`
		// 会一直生效：二级菜单在 details[open] 的那一刻就显形、不再等 .menu-opening，
		// 而 closeAnimation() 关闭时要把 open 保留 400ms，这段时间子菜单会一直露着。
		if (fallbackPanel) fallbackPanel.classList.remove("menu-drawer--fallback");

		// :not([role]) 精确排除构造函数已经处理过的那个主 summary。
		// 不能无差别重跑：addAccessibilityAttributes 会把 aria-expanded 重置成 false，
		// 而这一刻主 summary 正要变成展开态。
		this.addAccessibilityAttributes(this.querySelectorAll("summary:not([role])"));
		this.bindEvents();

		// 兜底路径专有：用户可能不只打开了主抽屉，还在 global.js 接管前继续打开了
		// 一个或多个子菜单（原生 <details> 不需要 JS 就能展开）。
		//
		// 这里补的是 **箭头方向和无障碍状态**，不是可见性 —— 可见性从来不受影响：
		// component-menu-drawer.css:62 的 `details[open] > .menu-drawer__submenu`
		// 特异度 (0,2,1) 本来就压过 :175 的 `.js .menu-drawer__submenu` (0,2,0)，
		// 所以只要 details 是 open，子菜单在有没有 .menu-opening / .menu-drawer--fallback
		// 的各种组合下都是 visible（浏览器实测过三种状态）。
		// .menu-opening 对子菜单的真实作用在 :24 —— `> summary > .icon-caret`
		// 旋转 180°；缺了它，展开着的子菜单箭头还朝着"收起"的方向。
		// 构造函数则刚把所有 summary 的 aria-expanded 无差别重置成了 false。
		if (fallbackPanel && this.mainDetailsToggle) {
			this.mainDetailsToggle
				.querySelectorAll("details[open]")
				.forEach((details) => {
					details.classList.add("menu-opening");
					const summary = details.querySelector(":scope > summary");
					if (summary) summary.setAttribute("aria-expanded", "true");
				});

			if (this.mainDetailsToggle.open) {
				const mainSummary = this.mainDetailsToggle.querySelector(":scope > summary");
				if (mainSummary) {
					// 接管时补齐正常打开路径负责的 header 定位/配色、body 滚动锁和焦点锁。
					// 用户若已经点进子菜单，保留当前焦点，不把它强行拉回汉堡按钮。
					const activeElement = this.contains(document.activeElement)
						? document.activeElement
						: mainSummary;
					this.openMenuDrawer(mainSummary, activeElement);
				}
			}
		}

		// 广播给那些"在加载时扫一遍抽屉内部"的脚本：
		// assets/nav-color-swatch.js（By Color 菜单项前面的色块）、
		// assets/dark-mode.js（深色模式开关，bindToggleButtons 监听本事件）。
		// 后者目前不渲染（settings.dark_mode_toggle = false），是防御性接线。
		// 注意 detail.drawer 传的是 <header-drawer> 本身，监听方按它作用域去扫。
		document.dispatchEvent(
			new CustomEvent("menu-drawer:hydrated", { detail: { drawer: this } })
		);
		// 与 assets/internet-celebrity-wall_popup.js 的 celebrityPopupHydrate() 同理：
		// GLC 货币/翻译应用不监听 DOM 变化，后插入的内容要手动让它重扫一遍。
		// 抽屉里目前没有价格（实测 hydrate 后的 DOM 与线上逐字一致），
		// 但有大量文案，非英语访客走的是 reTranslate 那条。
		try {
			if (window._gelacy) {
				if (typeof window._gelacy.reConvert === "function") window._gelacy.reConvert();
				if (typeof window._gelacy.reTranslate === "function") window._gelacy.reTranslate();
			}
		} catch (e) { /* 应用未安装 / 版本变更 */ }
		return true;
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute("role", "button");
			element.setAttribute("aria-expanded", false);
			element.setAttribute("aria-controls", element.nextElementSibling.id);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute("open");

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			// 展开之前先把正文搬进来。必须在 openMenuDrawer 之前：
			// 它会 trapFocus(this.mainDetailsToggle, ...)，而 trapFocus 要枚举可聚焦元素。
			if (!isOpen) this.hydrateContent();
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement);
		} else {
			// 子菜单展开/收起时同步无障碍状态。原实现只加 .menu-opening（管箭头方向）和
			// trapFocus，从没设过 aria-expanded —— summary 上那个 false 是构造函数
			// addAccessibilityAttributes() 写死的初值，于是读屏在子菜单明明展开时
			// 仍然念"已折叠"。（这是主题的既有缺陷，不是延迟化引入的。）
			//
			// 必须双向：点 summary 收起走的也是这条分支，closeSubmenu() 只由
			// 子菜单里的"返回"按钮和 Esc 触发，指望它回落是接不上的。
			// isOpen 读的是 <details> 默认动作发生**之前**的状态，所以取反正好是目标态。
			summaryElement.setAttribute("aria-expanded", !isOpen);

			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button")
			);

			setTimeout(() => {
				if (detailsElement.open) detailsElement.classList.add("menu-opening");
			});
		}
	}

	openMenuDrawer(summaryElement, elementToFocus = summaryElement) {
		this.menuMotionJobs.get(this.mainDetailsToggle)?.();
		setTimeout(() => {
			if (this.mainDetailsToggle.open) this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, elementToFocus);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove("menu-opening");
			this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
				details.removeAttribute("open");
				details.classList.remove("menu-opening");
				// 子菜单的 aria 要跟着一起回落，否则下次打开抽屉时它们还挂着
				// aria-expanded="true"，而视觉上是收起的。
				const submenuSummary = details.querySelector(":scope > summary");
				if (submenuSummary) submenuSummary.setAttribute("aria-expanded", false);
			});
			this.mainDetailsToggle
				.querySelector("summary")
				.setAttribute("aria-expanded", false);
			document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`
			);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
			this.header =
				this.header || document.querySelector(".shopify-section-header");
			const main = document.querySelector("main");
			if (
				main
					.querySelectorAll(".shopify-section")[0]
					?.classList.contains("section--has-overlay") &&
				!this.header.classList.contains("animate")
			) {
				this.header.classList.add("color-background-1", "color-background-2");
			}
			if (
				this.header.classList.contains("color-background-1") &&
				!this.header.classList.contains("shopify-section-header-sticky")
			) {
				this.header.classList.add("color-background-2");
			}
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				//if (this.classList.contains("mobile-facets__wrapper"))
				//	this.closeMenuDrawer();
				//else this.closeMenuDrawer(event);
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove("menu-opening");
		// 与 onSummaryClick 里那次置 true 配对，否则关掉之后读屏仍报"已展开"
		const summaryElement = detailsElement.querySelector(":scope > summary");
		if (summaryElement) summaryElement.setAttribute("aria-expanded", false);
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		this.menuMotionJobs.get(detailsElement)?.();
		const panel = detailsElement === this.mainDetailsToggle
			? detailsElement.querySelector('.menu-drawer__inner-container, .facets__wrapper')
			: detailsElement.querySelector(':scope > .menu-drawer__submenu');
		this.menuMotionJobs.set(detailsElement, waitForThemeMotion(panel, () => {
			this.menuMotionJobs.delete(detailsElement);
			if (detailsElement.classList.contains('menu-opening')) return;
			detailsElement.removeAttribute('open');
			if (detailsElement.closest('details[open]')) {
				trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
			}
		}));
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement, elementToFocus = summaryElement) {
		this.menuMotionJobs.get(this.mainDetailsToggle)?.();
		this.header =
			this.header || document.querySelector(".shopify-section-header");
		// 运算符优先级：`a || b ? 1 : 0` 会被解析成 `(a || b) ? 1 : 0`，
		// 而不是本意的 `a || (b ? 1 : 0)`。原写法算出 1 之后就永远停在 1
		// （`(1 || b)` 恒真），等于把"只算一次然后记住"写成了"锁死在 1"。
		// 这是 Dawn 上游带过来的老写法。改成显式判断，不再依赖 0 恰好是 falsy。
		//
		// 另外 closest() 可能返回 null（这个抽屉不一定永远待在 .header-wrapper 里），
		// 原写法会直接抛 TypeError 打断整个开抽屉流程，顺手判空。
		//
		// ⚠ 本次是纯粹的写法修正，**行为不变**：本主题从来没有输出过
		// header-wrapper--border-bottom 这个类（全仓库只有这一处在读它；
		// sections/header.liquid 输出的是 header--border），
		// 所以条件恒为 false、borderOffset 修复前后都恒为 0。详见下面那条注释。
		if (this.borderOffset === undefined) {
			const headerWrapper = this.closest(".header-wrapper");
			this.borderOffset =
				headerWrapper &&
				headerWrapper.classList.contains("header-wrapper--border-bottom")
					? 1
					: 0;
		}
		// ⚠ 遗留：上面那个 1px 边框补偿其实是**死特性**。
		// sections/header.liquid 在开启 enable_border 时输出的类名是 header--border，
		// 而这里查的是 header-wrapper--border-bottom —— 全仓库没有任何 Liquid 输出它。
		// 线上实测：header--border 有 1 处，header-wrapper--border-bottom 0 处，
		// 所以 borderOffset 恒为 0，边框那 1px 从来没有被补偿过。
		// 没有顺手"修好"：把类名对齐会让 --header-bottom-position 少 1px、
		// 抽屉顶边真的挪一格，那是行为/视觉变更，不是 bug 修复，要单独决定。
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(
				this.header.getBoundingClientRect().bottom - this.borderOffset
			)}px`
		);

		if (
			this.header.classList.contains("color-background-2") &&
			!this.header.classList.contains("shopify-section-header-sticky")
		) {
			this.header.classList.remove("color-background-2");
		}

		const main = document.querySelector("main");
		if (
			main
				.querySelectorAll(".shopify-section")[0]
				?.classList.contains("section--has-overlay")
		) {
			this.header.classList.remove("color-background-2");
		}

		setTimeout(() => {
			if (this.mainDetailsToggle.open) this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, elementToFocus);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
}

customElements.define("header-drawer", HeaderDrawer);

class SearchModal extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#SearchModal-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);

		this.querySelector("#search-modal-close").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		if (document.querySelector("#search-icon-open") != null) {
			const cartLink = document.querySelector("#search-icon-open");
			cartLink.setAttribute("role", "button");
			cartLink.setAttribute("aria-haspopup", "dialog");
			cartLink.addEventListener("click", (event) => {
				event.preventDefault();
				this.open(cartLink);
			});
			cartLink.addEventListener("keydown", (event) => {
				if (event.key === " " || event.key === "Enter") {
					event.preventDefault();
					this.open(cartLink);
				}
			});
		}
	}

	open(triggeredBy) {
		if (this.classList.contains('active')) return;
		this.cancelOpenMotion?.();
		this.cancelCloseMotion?.();
		const ownsFocus = claimThemeDrawerFocus();
		if (triggeredBy) this.setActiveElement(triggeredBy);
		this.classList.remove('hiding');
		// 先读取关闭态，保证同一任务中激活时仍能产生过渡。
		const panel = this.querySelector('.search__content');
		if (panel) getComputedStyle(panel).transform;
		this.classList.add('animate', 'active');
		this.cancelOpenMotion = waitForThemeMotion(panel, () => {
				if (!this.isConnected || !this.classList.contains('active') || !ownsFocus()) return;
				const containerToTrapFocusOn = document.getElementById("search-modal");
				const focusElement =
					this.querySelector('.header__search input:not([type="hidden"])') ||
					this.querySelector(".search__main") ||
					this.querySelector(".search__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			});

		document.body.classList.add("overflow-hidden");
	}

	close() {
		if (!this.classList.contains('active')) return;
		this.cancelOpenMotion?.();
		this.cancelCloseMotion?.();
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		releaseThemeScrollLock();

		this.classList.add("hiding");

		this.cancelCloseMotion = waitForThemeMotion(this.querySelector('.search__content'), () => {
			if (!this.classList.contains('active')) this.classList.remove('hiding');
		});
	}

	disconnectedCallback() {
		if (this.classList.contains('active')) this.close();
		this.cancelOpenMotion?.();
		this.cancelCloseMotion?.();
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("search-modal", SearchModal);

class accountModal extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#accountModal-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);

		this.querySelector("#account-modal-close").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#account-icon-open");
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");
		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});
		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (this.classList.contains('active')) return;
		this.cancelOpenMotion?.();
		this.cancelCloseMotion?.();
		const ownsFocus = claimThemeDrawerFocus();
		if (triggeredBy) this.setActiveElement(triggeredBy);
		this.classList.remove('hiding');
		const panel = this.querySelector('.account__content');
		if (panel) getComputedStyle(panel).transform;
		this.classList.add('animate', 'active');
		this.cancelOpenMotion = waitForThemeMotion(panel, () => {
				if (!this.isConnected || !this.classList.contains('active') || !ownsFocus()) return;
				const containerToTrapFocusOn = document.getElementById("account-modal");
				const focusElement =
					getFocusableElements(this.querySelector('.account__main') || this)[0] ||
					this.querySelector(".account__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			});

		document.body.classList.add("overflow-hidden");
	}

	close() {
		if (!this.classList.contains('active')) return;
		this.cancelOpenMotion?.();
		this.cancelCloseMotion?.();
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		releaseThemeScrollLock();

		this.classList.add("hiding");

		this.cancelCloseMotion = waitForThemeMotion(this.querySelector('.account__content'), () => {
			if (!this.classList.contains('active')) this.classList.remove('hiding');
		});
	}

	disconnectedCallback() {
		if (this.classList.contains('active')) this.close();
		this.cancelOpenMotion?.();
		this.cancelCloseMotion?.();
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("account-modal", accountModal);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this, false)
		);
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", (event) => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide();
			});
		} else {
			this.addEventListener("click", (event) => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.cancelCloseMotion?.();
		this.classList.remove('hiding');
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden");
		getComputedStyle(this).backgroundColor;
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		//window.pauseAllMedia();
	}

	hide(isProductPage = false) {
		let isOpen = false

		this.removeAttribute('open')
		this.classList.add('hiding')

		if (!isProductPage) {
			removeTrapFocus(this.openedBy)
		}

		//window.pauseAllMedia();

		document.querySelectorAll("body > quick-add-modal").forEach((el) => {
			if (el.hasAttribute("open")) {
				isOpen = true;
			}
		});

		let CartDrawerNote = document.getElementById("CartDrawer-Note");
		let CartDrawerNoteAppla = document.getElementById("CartDrawer-Note-Applay");

		if (!isOpen) {
			releaseThemeScrollLock();
			document.body.dispatchEvent(new CustomEvent("modalClosed"));

			if (CartDrawerNote) {
				if (CartDrawerNote.value.trim() !== "") {
					CartDrawerNoteAppla.classList.add("show");
				} else {
					CartDrawerNoteAppla.classList.remove("show");
				}
			}
		}

		const images = document.querySelector(".product-media-modal__content");

		if (images) {
			images.classList.remove("zoom");
		}

		this.cancelCloseMotion?.();
		const panel = this.querySelector('.quick-add-modal__content, .product-popup-modal__content, .banner-popup-modal__content, .banner-popup-product-modal__content, [role="dialog"]') || this;
		this.cancelCloseMotion = waitForThemeMotion(panel, () => {
			if (!this.hasAttribute('open')) this.classList.remove('hiding');
		}, { properties: ['transform', 'opacity'] });
	}
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			if (modal) modal.show(button);
		});

		if (this.closest(".product-popup") != null) {
			this.addEventListener("click", () => {
				const modal = document.querySelector(this.getAttribute("data-modal"));
				if (modal) modal.show(button);
			});
		}
	}
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			"click",
			this.loadContent.bind(this)
		);
	}

	loadContent() {
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(true)
			);

			this.setAttribute("loaded", true);
			window.pauseAllMedia();
			this.appendChild(
				content.querySelector("video, model-viewer, iframe")
			).focus();

			if (
				this.closest(".swiper")?.swiper.slides[
					this.closest(".swiper").swiper.activeIndex
				].querySelector("model-viewer")
			) {
				if (
					!this.closest(".swiper")
						.swiper.slides[
							this.closest(".swiper").swiper.activeIndex
						].querySelector("model-viewer")
						.classList.contains("shopify-model-viewer-ui__disabled")
				) {
					this.closest(".swiper").swiper.params.noSwiping = true;
					this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
				}
			}
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
		this.updateVariantStatuses();

		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			if (!this.closest("floated-form")) {
				this.updateMedia();
			}
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

		this.options = Array.from(
			this.querySelectorAll("select"),
			(select) => select.value
		).concat(
			fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll("input")).find(
					(radio) => radio.checked
				).value;
			})
		);
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				return variant.options.length === this.options.length &&
					variant.options.every((option, index) => this.options[index] === option);
			});
		}
	}

	isHidden(elem) {
		const styles = window.getComputedStyle(elem);
		return styles.display === "none" || styles.visibility === "hidden";
	}

	updateMedia() {
		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

		const newMedia = document.querySelector(
			`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
		);

		const parent = newMedia.parentElement;

		const swiperWrappers = document.querySelectorAll(".product__media-wrapper");

		swiperWrappers.forEach((elem) => {
			if (!this.isHidden(elem)) {
				const newMedia = elem.querySelector(
					`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
				);

				if (elem.querySelector(".js-media-list")) {
					elem
						.querySelector(".js-media-list")
						.swiper.slideTo(
							elem
								.querySelector(".js-media-list")
								.swiper.slides.indexOf(newMedia)
						);
				} else {
					newMedia && parent.prepend(newMedia);

					window.setTimeout(() => {
						parent.scroll(0, 0);
					});
				}
			}
		});
	}

	updateURL() {
		if (!this.classList.contains("featured-product-radios")) {
			if (!this.currentVariant || this.dataset.updateUrl === "false") return;
			window.history.replaceState(
				{},
				"",
				`${this.dataset.url}?variant=${this.currentVariant.id}`
			);
		}
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(":checked").value === variant.option1
		);
		const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			];
			const previousOptionSelected =
				inputWrappers[index - 1].querySelector(":checked").value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant[`option${index}`] === previousOptionSelected
				)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				if (input.tagName === "OPTION") {
					input.innerText = input.getAttribute("value");
				} else if (input.tagName === "INPUT") {
					input.classList.remove("disabled");
				}
			} else {
				if (input.tagName === "OPTION") {
					input.innerText =
						window.variantStrings.unavailable_with_option.replace(
							"[value]",
							input.getAttribute("value")
						);
				} else if (input.tagName === "INPUT") {
					input.classList.add("disabled");
				}
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section;

		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`
		)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, "text/html");
				const destination = document.getElementById(
					`price-${this.dataset.section}`
				);
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const skuDestination = document.getElementById(
					`Sku-${this.dataset.section}`
				);
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`
				);
				const colorNameSource = html.getElementById(
					`ColorName-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const colorNameDestination = document.getElementById(
					`ColorName-${this.dataset.section}`
				);

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle(
						"visibility-hidden",
						skuSource.classList.contains("visibility-hidden")
					);
				}
				if (colorNameSource && colorNameDestination)
					colorNameDestination.innerHTML = colorNameSource.innerHTML;

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove("visibility-hidden");

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						"visibility-hidden",
						inventorySource.innerText === ""
					);

				this.toggleAddButton(
					!this.currentVariant.available,
					window.variantStrings.soldOut
				);
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		const notifyButton = document.getElementById(
			`notify-button-${this.dataset.section}`
		);

		if (!addButton) return;

		if (disable) {
			addButton.setAttribute("disabled", "disabled");

			if (text) addButtonText.textContent = text;
			if (text) notifyButton?.setAttribute("disabled", "disabled");
		} else {
			addButton.removeAttribute("disabled");
			notifyButton?.removeAttribute("disabled");
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`
		);
		const addButton = button.querySelector('[name="add"]');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`
		);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);

		if (!addButton) return;
		this.toggleAddButton(true, window.variantStrings.unavailable);
		if (price) price.classList.add("visibility-hidden");
		if (inventory) inventory.classList.add("visibility-hidden");
		if (sku) sku.classList.add("visibility-hidden");
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.classList.remove("disabled");
			} else {
				input.classList.add("disabled");
			}
		});
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked
			).value;
		});
	}
}

customElements.define("variant-radios", VariantRadios);

class PasswordViewer {
	constructor() {
		const passwordField = document.querySelectorAll(".field--pass");

		passwordField.forEach((el) => {
			const input = el.querySelector("input");
			const btnWrapper = el.querySelector(".button-pass-visibility");
			const btnOpen =
				el.querySelector(".icon-eye-close") !== null
					? el.querySelector(".icon-eye-close")
					: el.querySelector(".pass-hide");
			const btnClose =
				el.querySelector(".icon-eye") !== null
					? el.querySelector(".icon-eye")
					: el.querySelector(".pass-show");

			input.addEventListener("input", () => {
				input.value !== ""
					? (btnWrapper.style.display = "block")
					: (btnWrapper.style.display = "none");
			});

			btnOpen.addEventListener("click", () => {
				input.type = "text";
				btnOpen.style.display = "none";
				btnClose.style.display = "block";
			});

			btnClose.addEventListener("click", () => {
				input.type = "password";
				btnOpen.style.display = "block";
				btnClose.style.display = "none";
			});
		});
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement("div");
					html.innerHTML = text;
					const recommendations = html.querySelector("product-recommendations");
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}

					/* Color swatches：统一走 product-card.js 的实现。
					   这里原本内联了一整份旧版拷贝 —— 没有重复绑定保护、没有请求令牌、
					   没有动画所有权、slider 下 .js-color-swatches-link 没判空，
					   而且它扫的是整个 document，会给页面上已经绑定过的卡片再挂一遍监听，
					   等于把已经修好的问题原样带回来。不要维护两份换图代码。 */
					if (window.colorSwatches) window.colorSwatches();

					const calcTop = (section) => {
						const imageWrapper = section.querySelectorAll(".card__inner");
						let top = 0;

						if (imageWrapper) {
							top = imageWrapper[0]?.offsetHeight / 2;
						} else {
							top = 50;
						}

						return top;
					};

					const initSlider = () => {
						document
							.querySelectorAll(".js-recommendation-swiper")
							.forEach((elem, index) => {
								let mobileLayout = 1;
								if (elem.dataset.mobileLayout) {
									mobileLayout = elem.dataset.mobileLayout;
								}
								let slider = new Swiper(elem, {
									slidesPerView: mobileLayout,
									spaceBetween: 8,
									speed: 600,
									navigation: {
										nextEl: elem.querySelector(
											".product-recommendations__slider-nav .swiper-button-next"
										),
										prevEl: elem.querySelector(
											".product-recommendations__slider-nav .swiper-button-prev"
										),
									},
									breakpoints: {
										576: {
											slidesPerView: 2,
										},
									},
								});
							});
					};

					const initSection = () => {
						const section = this;

						const sectionResizeObserver = new ResizeObserver((entries) => {
							const [entry] = entries;
							let top = calcTop(section);
							if (section.querySelector(".product-recommendations__slider-nav"))
								section.querySelector(
									".product-recommendations__slider-nav"
								).style.top = top + "px";
						});

						sectionResizeObserver.observe(section);

						initSlider();
					};

					const initProductSlider = () => {
						const sliders = document.querySelectorAll(".product-card-js");

						sliders.forEach((slider, index) => {
							const productSlider = new Swiper(slider, {
								pagination: {
									el: ".product-pagination .swiper-pagination",
								},
								navigation: {
									nextEl: ".product-button-group .swiper-button-next",
									prevEl: ".product-button-group .swiper-button-prev",
								},
							});
						});
					};

					initProductSlider();

					initSection();
				})
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: "0px 0px 200px 0px",
		}).observe(this);
	}
}

customElements.define("product-recommendations", ProductRecommendations);

(function () {




	const initHeaderOverlay = () => {
		const main = document.getElementById("MainContent");
		const sections = main.querySelectorAll(".shopify-section");
		if (sections.length > 0) {
			const sectionFirstChild = sections[0].querySelector(
				".section--has-overlay"
			);
			const headerGroupSections = document.querySelectorAll(
				".shopify-section-group-header-group"
			);
			const header = document.querySelector(".shopify-section-header");

			if (sectionFirstChild) {
				if (sectionFirstChild.classList.contains("section--has-overlay")) {
					if (headerGroupSections[headerGroupSections.length - 1] === header) {
						sections[0].classList.remove("not-margin");
						header.classList.add("color-background-1", "color-background-2");
					} else {
						sections[0].classList.add("not-margin");
						header.classList.remove("color-background-1", "color-background-2");
					}
				} else {
					sections[0].classList.remove("not-margin");
					header.classList.remove("color-background-1", "color-background-2");
				}
			}
		}
	};

	initHeaderOverlay();

	document.addEventListener("shopify:section:load", function () {
		initHeaderOverlay();
	});

	document.addEventListener("shopify:section:unload", function () {
		initHeaderOverlay();
	});

	document.addEventListener("shopify:section:reorder", function () {
		initHeaderOverlay();
	});
})();

function formatMoney(cents, format = "") {
	if (typeof cents === "string") {
		cents = cents.replace(".", "");
	}

	cents = parseInt(cents, 10);
	let value = "";
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	const formatString = format || theme.moneyFormat;

	function formatWithDelimiters(
		number,
		precision = 2,
		thousands = ",",
		decimal = "."
	) {
		if (isNaN(number) || number == null) {
			return '0';
		}

		number = (number / 100.0).toFixed(precision);

		const parts = number.split('.');
		const dollarsAmount = parts[0].replace(
			/(\d)(?=(\d{3})+(?!\d))/g,
			`$1${thousands}`
		);
		const centsAmount = precision > 0 ? decimal + parts[1] : '';

		return dollarsAmount + centsAmount;
	}

	const match = formatString.match(placeholderRegex);
	const formatType = match ? match[1] : 'amount';

	switch (formatType) {
		case 'amount':
			value = formatWithDelimiters(cents, 2, ',', '.');
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0, ',', '.');
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break
		case 'amount_with_apostrophe_separator':
			value = formatWithDelimiters(cents, 2, "'", '.');
			break
		case 'amount_no_decimals_with_space_separator':
			value = formatWithDelimiters(cents, 0, ' ', '.');
			break
		case 'amount_with_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', ',');
			break
		case 'amount_with_period_and_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', '.');
			break
		default:
			value = formatWithDelimiters(cents, 2, ',', '.');
	}

	return formatString.replace(placeholderRegex, value);
}

class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector(
				'input[name="locale_code"], input[name="country_code"]'
			),
			button: this.querySelector(".disclosure__button-modal"),
			panel: this.querySelector("ul"),
			buttonSave: this.querySelector(".button-save"),
			buttonSpan: this.querySelector(".disclosure__button-modal span"),
		};

		// Example usage:
		const targetElement = this.elements.button;
		const excludeElement = this.elements.panel;

		this.elements.button?.addEventListener(
			"click",
			this.openSelector.bind(this)
		);
		this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

		this.querySelectorAll("a").forEach((item) =>
			item.addEventListener("click", this.onItemClick.bind(this))
		);

		this.elements.buttonSave?.addEventListener(
			"click",
			this.onClickSave.bind(this)
		);

		this.handleClickOutside(targetElement, excludeElement);
	}

	hidePanel() {
		this.elements.button.setAttribute("aria-expanded", "false");
		this.elements.panel.setAttribute("hidden", true);
	}

	handleClickOutside(target, exclude) {
		document.addEventListener("click", (event) => {
			if (
				!target.contains(event.target) &&
				(!exclude || !exclude.contains(event.target))
			) {
				this.hidePanel();
			}
		});
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		this.hidePanel();
		this.elements.button.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		this.elements.input.value = event.currentTarget.dataset.value;
		if (
			document.querySelectorAll(".region_language_dropdown_type").length > 0
		) {
			this.querySelector("form")?.submit();
		} else {
			let itemValue = event.currentTarget.dataset.valuesave;
			this.elements.buttonSpan.textContent = event.currentTarget.textContent;
			this.elements.button.setAttribute("data-value", itemValue);
			this.hidePanel();
		}
	}

	onClickSave() {
		this.querySelector("form")?.submit();
	}

	openSelector() {
		this.elements.button.focus();
		this.elements.panel.toggleAttribute("hidden");
		this.elements.button.setAttribute(
			"aria-expanded",
			(
				this.elements.button.getAttribute("aria-expanded") === "false"
			).toString()
		);
		document.body.classList.add("region-open");
	}

	closeSelector(event) {
		if (!this.contains(event.relatedTarget)) {
			this.hidePanel();
		}
	}
}

customElements.define("localization-form", LocalizationForm);

(function initImageNumberTracking() {
	let frame = 0;
	const update = () => {
		frame = 0;
		const counters = document.querySelectorAll("#image_number .first_number");
		if (!counters.length) return;
		const images = $(".img-responsive");
		const scrollTop = window.scrollY;
		let i = 2;
		for (; i < images.length; i++) {
			if (images.eq(i).offset().top - scrollTop > 32) break;
		}
		const text = i > 10 ? String(i) : "0" + i;
		counters.forEach(counter => {
			if (counter.textContent !== text) counter.textContent = text;
		});
	};
	const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
	const refresh = () => {
		document.removeEventListener('scroll', schedule);
		if (frame) cancelAnimationFrame(frame);
		frame = 0;
		if (!document.querySelector('#image_number .first_number')) return;
		document.addEventListener('scroll', schedule, { passive: true });
		update();
	};
	document.addEventListener('DOMContentLoaded', refresh);
	document.addEventListener('shopify:section:load', refresh);
	document.addEventListener('shopify:section:unload', event => {
		if (event.target.querySelector('#image_number')) {
			document.removeEventListener('scroll', schedule);
			if (frame) cancelAnimationFrame(frame);
			frame = 0;
		}
	});
})();

(function () {
	const selectDropDown = () => {
		$(".product-form__controls--dropdown").each(function () {
			const elListItem = $(this).find(".dropdown-select ul li");
			const elItem = $(this).find(".dropdown-select ul");
			const selectedText = $(this).find(".dropdown-select .select-label");

			selectedText.on("click", function (e) {
				elItem.toggleClass("active");
				if (elItem.hasClass("active")) {
					e.stopPropagation();
					$(document).click(function () {
						elItem.removeClass("active");
					});
				}
			});

			elListItem.on("click", function () {
				if ($(this).find("input").hasClass("disabled") == false) {
					selectedText
						.find("span")
						.text($(this).text())
						.attr("title", $(this).text());
				}

				elItem.removeClass("active");
				document.activeElement.blur();
			});
		});
	};
	document.addEventListener("DOMContentLoaded", function () {
		selectDropDown();
		document.addEventListener("shopify:section:load", function () {
			selectDropDown();
		});
	});

  
})();


